// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"89":"news_list","946":"news"}[chunkId] + "." + {"89":"61d0488b","946":"9665e78e"}[chunkId] + ".css";
};